// extracted by mini-css-extract-plugin
export default {"modal":"style_modal__Pm3cF","header":"style_header__lqurw","title":"style_title__orTym","closeModal":"style_closeModal__DEdto"};